import axios from 'axios';

import { Resolve } from './';
import config from './config';

const url = process.env.VUE_APP_SERVER_PATH;

export interface IClientPaymentPlan {
  client_account: number;
  payment_plan: number;
  billing_cycle?: string;
  payment_option?: string;
  subscription_current_period_end?: string;
}

export const assignClientToPlan = (payload: IClientPaymentPlan) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .post(`${url}/v2/client-payment-plans`, payload, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});